// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__eDfFn","icon":"Loading_icon__3Yy7F","rotate":"Loading_rotate__1yl-s"};